import { NavLink } from 'react-router-dom'
import { Home, MessageCircle, User, Gamepad2, Music } from 'lucide-react'

export default function BottomNav() {
  const navItems = [
    { to: '/', icon: Home, label: '首页' },
    { to: '/messages', icon: MessageCircle, label: '消息' },
    { to: '/game', icon: Gamepad2, label: '游戏' },
    { to: '/music', icon: Music, label: '音乐' },
    { to: '/profile', icon: User, label: '我的' },
  ]

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-telegram-dark border-t border-telegram-secondary/10 safe-area-bottom z-40">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto">
        {navItems.map((item) => {
          const IconComponent = item.icon
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                  isActive
                    ? 'text-telegram-blue'
                    : 'text-telegram-secondary hover:text-telegram-text'
                }`
              }
            >
              <IconComponent className="w-6 h-6" />
              <span className="text-xs mt-1">{item.label}</span>
            </NavLink>
          )
        })}
      </div>
    </nav>
  )
}
